import { memo } from 'preact/compat';

export type SingleCountry = {
	id: number;
	properties: {
		name: string;
	};
	d: string;
};

export type CountryProps = {
	country: SingleCountry;
	data?: { [ key: string ]: any };
	pathAttributes?: { [ key: string ]: string };
	callback?: ( data?: any ) => void;
};

/**
 * Country component. Memo'd to reduce re-renders.
 *
 * @param {Object}   props                - component props
 * @param {Object}   props.country        - country object from topojson.
 * @param {Object}   props.data           - additional data to store for this county, passed to the callback function.
 * @param {Object}   props.pathAttributes - attributes object for the country to be spread on the path. Example: { fill: 'red', stroke: 'black' }.
 * @param {Function} props.callback       - callback function to run when the country is clicked.
 * @return {*} jsx
 */
export const Country = memo( ( {
	country,
	data,
	pathAttributes = { fill: 'darkgreen', stroke: 'white', className: 'country' },
	callback = () => {
		// eslint-disable-next-line no-console
		console.log( 'default country cb', { country, data } );
	},
}: CountryProps ): any => {
	const { id, properties, d } = country;
	const { name } = properties;

	return (
		<path
			d={ d }
			onClick={ () => callback() }
			data-country-id={ id }
			data-country-name={ name }
			{ ...pathAttributes }
		>
			<title>{ name }</title>
		</path>
	);
} );
